<template>
  <div id="aboutpartner" class="flex-full">
    <section class="head-image w-100 bg-cl-th-accent cl-white ">
      <div class="container head-image-bg w-100 h-100 cl-black" v-background-image="s3Path(store.background)">
        <div class="head-image-content w-100 flex center-xs pt10 pb10">
          <h1 class=" middle-xs underline cl-white ">
            {{ $t(store.title) }}
          </h1>
          <p href="#" class="fs16 store-title middle-xs ">
            {{ $t(store.subtitle) }}
          </p>
          <ul class="col-xs-12 align-left">
            <li class="partner-list flex middle-xs my10">
              <span class="material-icons mr10">done</span>
              {{ $t('Increase in sales by 15% or more') }}
            </li>
            <li class="partner-list flex middle-xs my10">
              <span class="material-icons mr10">done</span>
              {{ $t('You get a ready-made online store') }}
            </li>
            <li class="partner-list flex middle-xs my10">
              <span class="material-icons mr10">done</span>
              {{ $t('Compete with other trading shops and win!') }}
            </li>
          </ul>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="form-partner row pt10 pb10 center-xs">
        <div class="col-xs-12 col-md-6">
          <p class="fs16 cl-mine-shaft">
            {{ $t('Join independent trading partners who are growing their business online.') }}
          </p>
          <div>
            <div class="mb10">
              <div class="fieldwrap row pt10 center-xs">
                <base-input
                  class="col-xs-12 mb10  input"
                  type="text"
                  name="store-name"
                  v-model.trim="partner.storeName"
                  @blur="$v.partner.storeName.$touch()"
                  :placeholder="$t('Store Name *')"
                  :validations="[{
                    condition: $v.partner.storeName.$error && !$v.partner.storeName.required,
                    text: $t('Field is required.')
                  }]"
                />
                <base-input
                  class="col-xs-12 mb10 input"
                  type="text"
                  name="name"
                  v-model.trim="partner.name"
                  @blur="$v.partner.name.$touch()"
                  :placeholder="$t('Name *')"
                  :validations="[{
                    condition: $v.partner.name.$error && !$v.partner.name.required,
                    text: $t('Field is required.')
                  }]"
                />
                <base-telephone-input
                  class="col-xs-12 mb10"
                  :required="true"
                  :validations="phoneValidations"
                  :value="partner.phoneNumber"
                  @update="updatePhoneNumber"
                  @input="$v.partner.phoneNumber.$touch()"
                />
                <base-input
                  class="col-xs-12 mb10 input"
                  type="email"
                  name="email-address"
                  v-model.trim="partner.email"
                  @blur="$v.partner.email.$touch()"
                  :placeholder="$t('Email address *')"
                  autocomplete="email"
                  :validations="[
                    {
                      condition: $v.partner.email.$error && !$v.partner.email.required,
                      text: $t('Field is required.')
                    },
                    {
                      condition: !$v.partner.email.email,
                      text: $t('Please provide valid e-mail address.')
                    },
                  ]"
                />
                <base-input
                  class="col-xs-12 mb10 input"
                  type="text"
                  name="address"
                  v-model.trim="partner.address"
                  @blur="$v.partner.address.$touch()"
                  :placeholder="$t('Store address *')"
                  :validations="[
                    {
                      condition: $v.partner.address.$error && !$v.partner.address.required,
                      text: $t('Field is required.')
                    }
                  ]"
                />
                <base-input
                  class="col-xs-12 mb10 input"
                  type="text"
                  name="index"
                  v-model.trim="partner.index"
                  @blur="$v.partner.index.$touch()"
                  :placeholder="$t('Index *')"
                  :validations="[
                    {
                      condition: $v.partner.index.$error && !$v.partner.index.required,
                      text: $t('Field is required.')
                    },
                    {
                      condition: $v.partner.index.$error && !$v.partner.index.numeric && $v.partner.index.required,
                      text: $t('The field is must be numeric.')
                    }
                  ]"
                />
                <base-input
                  class="col-xs-12 mb10 input"
                  type="text"
                  name="number-of-stores"
                  v-model.trim="partner.numberOfStores"
                  @blur="$v.partner.numberOfStores.$touch()"
                  :placeholder="$t('Number of institutions *')"
                  :validations="[
                    {
                      condition: $v.partner.numberOfStores.$error && !$v.partner.numberOfStores.required,
                      text: $t('Field is required.')
                    },
                    {
                      condition: $v.partner.numberOfStores.$error && !$v.partner.numberOfStores.numeric && $v.partner.numberOfStores.required,
                      text: $t('The field is must be numeric.')
                    }
                  ]"
                />
                <base-input
                  class="col-xs-12 mb10 input"
                  type="text"
                  name="number-of-stores"
                  v-model.trim="partner.socialLink"
                  @blur="$v.partner.socialLink.$touch()"
                  :placeholder="$t('Link on social network')"
                />
                <button-full
                  class="mb35 col-xs-6 bg-cl-korzyna-green button-korzyna"
                  type="submit"
                  @click.native="validateForm"
                >
                  {{ $t('Send') }}
                </button-full>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row pt10 pb10 center-xs">
        <p class="h4 weight-700">{{ $t('Get to know our partners') }}</p>
        <div class="partner-slides w-100" v-if="stores && stores.length">
          <button class="slick-button slick-button-prev responsibility"
                  :class="{ 'slick-button-green': currentPage < partners.length - slidesPerPage }"
                  @click="showNext"
          >
            <i class="material-icons p15 pointer">keyboard_arrow_right</i>
          </button>
          <VueSlickCarousel
            v-bind="config"
            ref="slick"
            class="all-partner-slider"
            @afterChange="setMuted">
            <div class="store-img" :key="partner.id" v-for="partner in partners">
              <div class="flex middle-xs relative">
                <images-lazy-load class="partner-img" :image="{ src: partnerLogo(partner) }" :alt="partner.name" :width="90" :height="56"/>
              </div>
            </div>
          </VueSlickCarousel>
          <button class="slick-button slick-button-next responsibility"
                  :class="{ 'slick-button-green': currentPage > 0 }"
                  @click="showPrevious"
          >
            <i class="material-icons p15 pointer">keyboard_arrow_left</i>
          </button>
        </div>
      </div>
      <div class="row pt10 pb10 center-xs">
        <div class="col-xs-12 col-md-10">
          <p class="fs16 cl-mine-shaft">
            {{ $t('We provide you with e-commerce, shipping, marketing, service and more.') }}
          </p>
          <div slot="content row center-xs">
            <div class="main row">
              <div class="card col-md-4 col-sm-6 col-xs-6  pt20">
                <div class="card-wrap">
                  <div class="no-underline parent-link">
                    <div class="row parent center-xs">
                      <img width="76" height="66" src="../assets/icons/group-11.svg" alt="cart" loading="eager" fetchpriority="high">
                      <p class="col-xs-12 center-xs fs16  weight-500 my10">{{ $t('Electronic trade') }}</p>
                      <p class="col-xs-12 center-xs h5 m0 text-more">
                        {{ $t('Designed for flexibility and control') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-4 col-sm-6 col-xs-6  pt20">
                <div class="card-wrap">
                  <div class="no-underline parent-link">
                    <div class="row parent center-xs">
                      <img width="76" height="68" src="../assets/icons/group-12.svg" alt="scutter" loading="eager" fetchpriority="high">
                      <p class="col-xs-12 center-xs fs16  weight-500 my10">{{ $t('Delivery') }}</p>
                      <p class="col-xs-12 center-xs h5 m0 text-more">
                        {{ $t('We deliver or you - all options are considered!') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-4 col-sm-6 col-xs-6  pt20">
                <div class="card-wrap">
                  <div class="no-underline parent-link">
                    <div class="row parent center-xs">
                      <img width="72" height="69" src="../assets/icons/group-14.svg" alt="horn" loading="eager"
                           fetchpriority="high">
                      <p class="col-xs-12 center-xs fs16  weight-500 my10">{{ $t('Marketing') }}</p>
                      <p class="col-xs-12 center-xs h5 m0 text-more">
                        {{ $t('Harness the power of the e-commerce marketplace') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-4 col-sm-6 col-xs-6  pt20">
                <div class="card-wrap">
                  <div class="no-underline parent-link">
                    <div class="row parent center-xs">
                      <img width="66" height="69" src="../assets/icons/group-15.svg" alt="operator" loading="eager"
                           fetchpriority="high">
                      <p class="col-xs-12 center-xs fs16  weight-500 my10">{{ $t('Service') }}</p>
                      <p class="col-xs-12 center-xs h5 m0 text-more">
                        {{ $t('Focus on the benefits, leave the headaches to us') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card col-md-4 col-sm-6 col-xs-6  pt20">
                <div class="card-wrap">
                  <div class="no-underline parent-link">
                    <div class="row parent center-xs">
                      <img width="64" height="69" src="../assets/icons/group-16.svg" alt="community" loading="eager" fetchpriority="high">
                      <p class="col-xs-12 center-xs fs16  weight-500 my10">{{ $t('Software') }}</p>
                      <p class="col-xs-12 center-xs h5 m0 text-more">
                        {{ $t('Centralize phone, email and online ordering') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card  col-md-4 col-sm-6 col-xs-6 pt20">
                <div class="card-wrap cardFront">
                  <div class="no-underline parent-link">
                    <div class="row parent center-xs">
                      <img width="66" height="72" src="../assets/icons/group-17.svg" alt="website" loading="eager" fetchpriority="high">
                      <p class="col-xs-12 center-xs fs16 weight-500 my10">{{ $t('Personalization') }}</p>
                      <p class="col-xs-12 center-xs h5 m0 text-more">{{ $t('Your store is unique!') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <instagram-feed/>
  </div>
</template>

<script async>
import config from 'config';
import backgroundImage from 'theme/directives/background-image';
import { email, numeric, required } from 'vuelidate/lib/validators';
import { onlineHelper, processURLAddress, s3Path } from '@vue-storefront/core/helpers';
import { mapActions, mapGetters } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

const BaseTelephoneInput = () => import(/* webpackChunkName: "vsf-base-telephone-input" */ 'theme/components/core/blocks/Form/BaseTelephoneInput.vue');

const InstagramFeed = () => import(/* webpackChunkName: "vsf-instagram-feed" */ 'theme/components/theme/blocks/InstagramFeed/InstagramFeed');
const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput.vue');
const ButtonFull = () => import(/* webpackChunkName: "vsf-button-full" */ 'theme/components/theme/ButtonFull.vue');
const ImagesLazyLoad = () => import(/* webpackChunkName: "vsf-images-lazy-load" */ 'theme/components/core/ImagesLazyLoad.vue');

export default {
  data () {
    return {
      store: {
        background: '../../../assets/bg-home.png',
        title: 'Become our partner',
        subtitle: 'What will you get?'
      },
      maxPage: 0,
      currentPage: 0,
      partner: {
        storeName: '',
        name: '',
        phoneNumber: '',
        email: '',
        index: '',
        numberOfStores: '',
        address: '',
        socialLink: ''
      },
      loadModal: false,
      config: {
        dots: false,
        dotsClass: 'slick-dots custom-dot-class',
        infinite: false,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 8,
        responsive: [
          {
            'breakpoint': 1024,
            'settings': {
              'slidesToShow': 6,
              'slidesToScroll': 6,
              'arrows': false
            }
          },
          {
            'breakpoint': 500,
            'settings': {
              'slidesToShow': 4,
              'slidesToScroll': 4,
              'arrows': false
            }
          },
          {
            'breakpoint': 320,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 3,
              'arrows': false
            }
          }
        ]
      },
      phoneMeta: {
        isValid: false
      }
    }
  },
  components: {
    ImagesLazyLoad,
    InstagramFeed,
    ButtonFull,
    BaseInput,
    VueSlickCarousel,
    BaseTelephoneInput
  },
  directives: {
    backgroundImage
  },
  computed: {
    ...mapGetters({
      stores: 'partners/getPartners',
      user: ['isLoggedIn']
    }),
    slidesPerPage() {
      if (window.innerWidth < 320) {
        return 3;
      }
      if (window.innerWidth < 500) {
        return 4;
      }
      if (window.innerWidth < 1024) {
        return 6;
      }
      return 8;
    },
    partners() {
      return this.stores.filter(store => store.code !== 'all-discounts' && store.code !== 'anywhere' && store.code !== 'sertyfikaty')
    },
    isOnline() {
      return onlineHelper.isOnline
    },
    phoneValidations() {
      return [
        {
          condition: this.$v.partner.phoneNumber.$error && !this.$v.partner.phoneNumber.required,
          text: this.$t('Field is required.')
        },
        {
          condition: this.$v.partner.phoneNumber.$error && this.$v.partner.phoneNumber.required && !this.$v.partner.phoneNumber.isValid,
          text: this.$t('Incorrect type of number')
        }
      ]
    }
  },
  created() {
    // Load personal and shipping details for Checkout page from IndexedDB
    this.$store.dispatch('checkout/load')
  },
  async beforeMount() {
    // Logo slider only; `tags` because getPartners filters by the selected tag.
    this.loadPartners({ include: ['id', 'entity_id', 'code', 'name', 'logo_path', 'location_code', 'tags'] })
    if (this.$store.state.__DEMO_MODE__) {
      const onboardingClaim = await this.$store.dispatch('claims/check', {claimCode: 'onboardingAccepted'})
      if (!onboardingClaim) { // show onboarding info
        this.$bus.$emit('modal-toggle', 'modal-onboard')
        this.$store.dispatch('claims/set', {claimCode: 'onboardingAccepted', value: true})
      }
    }
  },
  mounted() {
    if (!this.isLoggedIn && localStorage.getItem('redirect')) this.$bus.$emit('modal-show', 'modal-signup')
  },
  metaInfo () {
    return {
      title: this.$t(this.$route.meta.title) || this.$t(this.$props.title),
      meta: this.$route.meta.description ? [{vmid: 'description', description: this.$t(this.$route.meta.description)}] : []
    }
  },
  methods: {
    s3Path,
    updatePhoneNumber(value) {
      this.phoneMeta = value;

      if ('formattedNumber' in value) {
        this.partner.phoneNumber = value.formattedNumber;
      }
    },
    validateForm() {
      if (this.$v.$invalid) {
        this.showErrors()
      } else {
        this.sendPartnerData()
      }
    },
    ...mapActions({
      loadPartners: 'partners/loadAllPartners'
    }),
    showErrors() {
      for (let field in this.partner) {
        this.$v.partner[field].$touch();
      }
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t('Some of the form fields are not valid!'),
        action1: {label: this.$t('OK')}
      })
    },
    sendPartnerData() {
      this.$bus.$emit('notification-progress-start', this.$t('Please wait ...'))
      fetch(processURLAddress(config.partnersEndpoints.sendInfo), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({partner: this.partner})
      }).then(() => {
        this.$bus.$emit('notification-progress-stop', {})
        for (let field in this.partner) {
          this.partner[field] = '';
          this.$v.$reset();
        }
        this.$store.dispatch('notification/spawnNotification', {
          type: 'success',
          message: this.$t('Your application has been successfully accepted for processing'),
          action1: {label: this.$t('OK')}
        })
      }).catch(error => {
        this.$bus.$emit('notification-progress-stop', {})
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t(error),
          action1: {label: this.$t('OK')}
        })
      })
    },
    showNext() {
      this.$refs.slick.next();
    },
    showPrevious() {
      this.$refs.slick.prev();
    },
    setMuted(currentPage) {
      if (currentPage >= this.maxPage) {
        this.maxPage = currentPage;
      }
      this.currentPage = currentPage
    },
    partnerLogo(partner) {
      return this.s3Path(partner.logo_path, config.images.partner_slider_logo.width, config.images.partner_slider_logo.height, true);
    }
  },
  watch: {
    isLoggedIn() {
      const redirectObj = localStorage.getItem('redirect')
      if (redirectObj) this.$router.push(redirectObj)
      localStorage.removeItem('redirect')
    }
  },
  validations() {
    return {
      partner: {
        storeName: {
          required
        },
        name: {
          required
        },
        phoneNumber: {
          required: () => required && 'phoneNumber' in this.phoneMeta,
          isValid: () => this.phoneMeta.isValid
        },
        email: {
          required,
          email
        },
        index: {
          required,
          numeric
        },
        numberOfStores: {
          required,
          numeric
        },
        address: {
          required
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 36px;
}.card {
  .card-wrap{
    text-align: center;
    position: relative;
    height: 100%;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
  }

  .text-more{
    line-height: 1.3em;
    height: 3.9em;
    margin-bottom: 15px;
  }
  img{
    width: 66px;
    height: 68px;
  }
}
#home{
  position: relative;
  top: -54px;
}
.new-collection {
  @media (max-width: 768px) {
    padding-top: 0;
  }
}
.menu-bottom {
  display: block;
  margin-top: -50px;}

.head-image {
  position: relative;

  .image-wrapper{
    width: 95px !important;
    height: 95px !important;
    margin-bottom: 10px;
    border-radius: 50%;
    -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
    background-color: white;
    padding: 10px;
    img{
      width: 100%;
      height: auto;
    }
  }

  .head-image-content {
    display: flex;
    flex-direction: column;
    align-items: center;


    p.store-title{
      color: #fff;
    }
    ul{
      list-style: none;
      li{
        color: #fff;
        span.material-icons{
          background-color: #11bb2e;
          color: #fff;
          width: 23px;
          height: 23px;
          border-radius: 50%;
        }
      }
    }
  }
  .head-image-bg{
    background-size: cover;
    background-position: bottom center;
    background-repeat: no-repeat;
  }
}
.form-partner{
  background-color: #f9f8f6;
}
.button-korzyna{
  border-radius: 10px;
  border: none;}

.about-slider{
  img{
    margin: 0 auto;
    @media (max-width: 768px){
      max-width: 300px;
      margin: 0 auto;
    }
  }

}

.partner-slides {
  position: relative;
  overflow: hidden;

  .store-img{
    width: 90% !important;
    height: 135px;
    border-radius: 15%;
    -webkit-box-shadow: rgba(0, 0, 0, 0.5) 0 1px 2px 0;
    box-shadow: rgba(0, 0, 0, 0.55) 0 1px 2px 0;
    background-color: white;
    display: inline-block;
    text-align: center;
    white-space: normal;
    vertical-align: middle;
    @media (max-width: 768px){
      height: 90px;
    }
    .flex{
      height: 100%;
      margin: 0 auto;
    }
    img{
      width: 90%;
      max-width: 90px;
      height: auto;
      margin: 0 auto;
      @media (max-width: 768px){
        max-width: 55px;}
      }
    }
  }

.partner-imag {
  max-height: 125px;
}
</style>

<style lang="scss">
.input{
  input{
    background-color: #fff;
    border-radius: 5px;
    padding-left: 10px;
    padding-top: 20px;
  }

  input:focus ~ label, input:not(.empty) ~ label {
    top: 0;
    font-size: 13px;
    color: #4dba87;
  }
}

.about-slider .slick-prev, .about-slider .slick-next {
  top: 380px;
  width: 25px;
  height: 25px;
  background-color: #f9f8f6;
  border-radius: 50%;
  z-index: 100;
  @media (max-width: 768px){
    top: 235px;
  }
}
.about-slider .slick-next:before {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.about-slider .slick-prev:before {
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);}

.about-slider .slick-prev:before, .about-slider .slick-next:before {
  content: '';
  background-image: url('../assets/icons/icon-hide.svg');
  background-position: center center;
  background-size: 18px 18px;
  background-repeat: no-repeat;
  display: block;
  height: 18px;}

.about-slider .slick-next {
  right: 40%;
  -webkit-transform: translateX(50px);
  -ms-transform: translateX(50px);
  transform: translateX(50px);
  @media (max-width: 768px){
    right: 35%;
  }
}
.about-slider .slick-prev {
  left: 40%;
  -webkit-transform: translateX(-50px);
  -ms-transform: translateX(-50px);
  transform: translateX(-50px);
  @media (max-width: 768px){
    left: 35%;}
  }

.slick-button {
  z-index: 1;
  border: 0px;
  border-radius: 50%;
  transition: opacity 200ms linear 0s;
  text-align: left;
  line-height: 1;
  color: rgb(255, 255, 255);
  width: 55px;
  height: 55px;
  padding: 0;

  i {
    font-size: 28px;
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}

.slick-button-green {
  background-color: rgba(0, 0, 0, 0.9);
  box-shadow: rgba(0, 0, 0, 0.26) 0px 1px 2px 0px, rgba(0, 0, 0, 0.16) 0px 1px 4px 0px;
}

.slick-button-prev {
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  i{
    left: 5px;
  }
}

.slick-button-next {
  position: absolute;
  left: -25px;
  top: 50%;
  transform: translateY(-50%);
  i{
    right: 5px;}
  }

.all-partner-slider {
  .slick-track {
    height: 158px;
    top: 15px!important;
    @media (max-width: 768px){
      height: 130px;
    }
  }
}

.partner-img {
  .image__thumb {
    max-width: calc(100% - 12px) !important;
  }
}
</style>
